export default {
  "Autocomplete.add": 'Add "{value}"',
  "Autocomplete.all_number_selected": "All {number} selected",
  "Autocomplete.all_number": "All ({number})",
  "Card.toggle_content": "toggle content",
  "Chip.remove": "remove",
  "DatePicker.next": "Next",
  "DatePicker.previous": "Previous",
  "Pagination.first": "first",
  "Pagination.go_to_page_number": "Go to page {index}",
  "Pagination.go_to_page": "Go to {label} page",
  "Pagination.last": "last",
  "Pagination.next": "next",
  "Pagination.previous": "previous",
  "Table.actions": "Table Actions",
  "Table.add_column": "Add Column",
  "Table.filter": "Filter",
  "Table.hide": "Hide",
  "Table.more_actions": "More Actions",
  "Table.move_left": "Move Left",
  "Table.move_right": "Move Right",
  "Table.not_specified": "Not specified",
  "Table.pagination": "Table Pagination",
  "Table.per_page": "Per page",
  "Table.position_zero": "0 of {total}",
  "Table.position": "{start}-{end} of {total}",
  "Table.search": "Search",
  "Table.select_all": "Select All",
  "Table.select_row": "Select {row}",
  "Table.sort_ascending": "Sort ascending",
  "Table.sort_descending": "Sort descending",
  "TextInput.clear_labelled_input": "Clear {label}",
  "Ui.clear_all": "Clear all",
  "Ui.close": "Close",
  "Ui.loading": "Loading",
  "Ui.no_results": "No results",
  "Ui.number_selected": "{number} selected",
  "Ui.remove": "Remove",
  "Ui.select_all": "Select all",
  "Ui.show_more": "+ {count} More",
}
